/**
 * Created by dmitry on 28.04.2025
 */

const Merge3BuildTutorial = function () {
    return new TutorialScenario("build_tutorial", {
        listSteps: Merge3BuildTutorial.listSteps,
        isAvailable: function () {
            return Map2dLocation.currentLocation && Map2dLocation.currentLocation.needsBuildTutorial;
        },
        onStart: function () {
            Map2dLocation.currentLocation.needsBuildTutorial = false;

            cleverapps.focusManager.setEventNodes([]);
        },
        onFinish: function () {
            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
        }
    });
};

Merge3BuildTutorial.TriggerBuildTutorial = function (unit) {
    if (Unit.Equals(unit, Merge3BuildTutorial.TARGET_UNIT) && !cleverapps.unitsLibrary.isOpened(unit) && !Map2d.currentMap.workers.findAssigned(unit) && !cleverapps.tutorial.isActive()) {
        Map2dLocation.currentLocation.needsBuildTutorial = true;
    }
};

Merge3BuildTutorial.listSteps = function () {
    const steps = [];

    Merge3BuildTutorial.STEPS.forEach((data) => {
        if (data.advice) {
            steps.push(MergeTutorialHelper.createAdviceStep(data.advice));
        }

        if (data.guideWindow) {
            steps.push(MergeTutorialHelper.createGuideWindowStep(data.guideWindow));
        }
    });

    return steps;
};

Merge3BuildTutorial.TARGET_UNIT = { code: "wood", stage: 2 };

Merge3BuildTutorial.STEPS = [
    {
        advice: {
            type: Map2d.START_BUILDING,
            targets: Merge3BuildTutorial.TARGET_UNIT,
            person: "worker",
            text: "Tutorial.build_wood_2.step1"
        }
    },
    {
        advice: {
            type: Map2d.SPEED_UP,
            targets: Merge3BuildTutorial.TARGET_UNIT,
            person: "worker",
            text: "Tutorial.build_wood_2.step2",
            nextStepDelay: 3
        }
    },
    {
        guideWindow: {
            name: "MergeGuideWindow",
            bundle: bundles.merge_guide_window,
            closeButtonDelay: true
        }
    }
];
